import { Component, FC, useMemo } from 'react';
import { useLocation, useNavigation, useOutletContext } from '@remix-run/react';
import { useAtomValue } from 'jotai';
import { $PageLevelTraffic } from 'shared/atoms';
import { RootSkeleton } from '~/skeleton';

export abstract class RemixPage extends Component {
  /**
   * @deprecated
   */
  get page(): string {
    throw new Error('page name unspecified');
  }

  Head: FC = () => {
    return null;
  };

  Body: FC = () => {
    return null;
  };

  protected HeadContent: FC = () => {
    const { state } = useNavigation();
    const { canonicalUrl } = useAtomValue($PageLevelTraffic);
    const { pathname } = useLocation();

    const routeLoading = useMemo(() => {
      if (__BUILD_TARGET__ === 'server') {
        return false;
      }

      const a = new URL(canonicalUrl);
      return location.pathname !== a.pathname;
    }, [pathname, canonicalUrl]);

    if (state === 'loading' || routeLoading) {
      return (
        <>
          <title>Lemon8 Loading</title>
        </>
      );
    }
    const { Head } = this;

    return <Head />;
  };

  protected BodyContent: FC = () => {
    const { state } = useNavigation();
    const { canonicalUrl } = useAtomValue($PageLevelTraffic);
    const { pathname } = useLocation();

    const routeLoading = useMemo(() => {
      if (__BUILD_TARGET__ === 'server') {
        return false;
      }

      const a = new URL(canonicalUrl);
      return location.pathname !== a.pathname;
    }, [pathname, canonicalUrl]);

    const { Body } = this;

    if (state === 'loading' || routeLoading) {
      return <RootSkeleton />;
    }

    return <Body />;
  };

  protected Content: FC = () => {
    const { HeadContent, BodyContent } = this;
    const { for: contextFor } = useOutletContext<{
      for: 'head' | 'body';
    }>();

    if (contextFor === 'head') {
      return <HeadContent />;
    } else {
      return <BodyContent />;
    }
  };

  override render(): JSX.Element {
    const { Content } = this;

    return <Content />;
  }
}
